module.exports = __webpack_public_path__ + "img/i-meeple-black.508efa9f.svg";